import OrganizationsStore from '../stores/observables/OrganizationsStore';
import { UserRolesStore } from '../stores/observables/UserStore';

// @note coded to be easily debuggable
export const canDo = (roles: string | string[]) => {
  const isCurrentSet = OrganizationsStore.isCurrentSet();
  if (isCurrentSet) {
    const currentRole = UserRolesStore.getCurrent();
    return roles.includes(currentRole?.role.name as string);
  }
  return false;
};
